import types from './types';
import { mapOperations } from '../map';

const initialState = {
  loaded: false,
  fieldInfos: [],
  preferences: {
    sqlFilters: {},
    resourceSqlFilters: {},
    incidentListColumns: [],
    incidentResourceListColumns: [],
    incidentRequestListColumns: [],
    incidentExperienceListColumns: [],
    resourceListColumns: [],
    mapColumnVisible: true
  }
};

const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CONFIG:
      return {
        ...state,
        ...action.payload.config,
        loaded: true,
        mapOperations: {
          loaded: true,
          mapColumnVisible: true



        }
      };

    case types.SET_ORIGIN_FIELD_INFOS:
      return {
        ...state,
        fieldInfos: action.payload.fieldInfos
      };

    case types.INIT_USER_PREFS:
      return {
        ...state,
        preferencesItemId: action.payload.id,
        preferences: action.payload.preferences
      };

    case types.ADD_SQL_FILTER:
      const { name, filter } = action.payload.filterDef;

      let addObj = {
        ...state,
        preferences: {
          ...state.preferences
        }
      };

      // check if payload is an incident or resource filter
      if (action.payload.isResources) {
        addObj.preferences.resourceSqlFilters = {
          ...state.preferences.resourceSqlFilters,
          [name]: { ...filter }
        };
      } else {
        addObj.preferences.sqlFilters = {
          ...state.preferences.sqlFilters,
          [name]: { ...filter }
        };
      }

      return addObj;

    case types.RENAME_SQL_FILTER:
      const {
        existingFilterName,
        newFilterName
      } = action.payload.filterRenameInfo;

      // NOTE: simply adding a new sql filter with the desired new name
      // and then deleting the existing sql filter from the sqlFilters object
      // will have the side-effect of changing the order of saved filter names
      // displayed in the SavedFilters component

      // we attempt to maintain the original order by borrowing from the "renameKeys"
      // method idea found here: https://30secondsofcode.org/object#renamekeys
      const renameKeysMap = {
        [existingFilterName]: newFilterName
      };

      // set filter set based on payload flag for resources
      const rnFilterSet = action.payload.isResources
        ? 'resourceSqlFilters'
        : 'sqlFilters';

      // update the filter name in the chosen filter set
      const sqlFiltersRename = Object.keys(
        state.preferences[rnFilterSet]
      ).reduce(
        (acc, key) => ({
          ...acc,
          ...{
            [renameKeysMap[key] || key]: state.preferences[rnFilterSet][key]
          }
        }),
        {}
      );

      // create the return object
      let modObj = {
        ...state,
        preferences: {
          ...state.preferences
        }
      };

      // update the filter set
      if (action.payload.isResources) {
        modObj.preferences.resourceSqlFilters = sqlFiltersRename;
      } else {
        modObj.preferences.sqlFilters = sqlFiltersRename;
      }

      return modObj;

    case types.REMOVE_SQL_FILTER:
      // set filter set based on payload flag for resources
      const rmFilterSet = action.payload.isResources
        ? 'resourceSqlFilters'
        : 'sqlFilters';

      const sqlFiltersRemove = state.preferences[rmFilterSet];
      delete sqlFiltersRemove[action.payload.name];

      let rmObj = {
        ...state,
        preferences: {
          ...state.preferences
        }
      };

      // update the filter set
      if (action.payload.isResources) {
        rmObj.preferences.resourceSqlFilters = sqlFiltersRemove;
      } else {
        rmObj.preferences.sqlFilters = sqlFiltersRemove;
      }

      return rmObj;

    case types.SET_INCIDENT_LIST_COLUMNS_PREFS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          incidentListColumns: action.payload.columns
        }
      };

    case types.SET_INCIDENT_RESOURCE_LIST_COLUMNS_PREFS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          incidentResourceListColumns: action.payload.columns
        }
      };

    case types.SET_INCIDENT_REQUEST_LIST_COLUMNS_PREFS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          incidentRequestListColumns: action.payload.columns
        }
      };

    case types.SET_INCIDENT_EXPERIENCE_LIST_COLUMNS_PREFS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          incidentExperienceListColumns: action.payload.columns
        }
      };

    case types.SET_RESOURCE_LIST_COLUMNS_PREFS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          resourceListColumns: action.payload.columns
        }
      };

    case types.SET_MAP_PREFS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          mapColumnVisible: action.payload.mapColumnVisible
        }
      };

    default:
      return state;
  }
};

export default configReducer;



// WEBPACK FOOTER //
// ./src/redux/config/reducers.js